import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface PanelSkeletonSection {
  title: string;
  fields: string[];
}

/**
 * Loading placeholder for the record side panels (task / note / ticket).
 *
 * Shows the panel's real headings and field labels with shimmering bars where the data
 * will appear, so the layout is already in place while the record is being fetched.
 * It fills the nearest positioned ancestor and sits above the panel's own header.
 */
@Component({
  selector: 'app-panel-loading-skeleton',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './panel-loading-skeleton.component.html',
  styleUrls: ['./panel-loading-skeleton.component.scss'],
})
export class PanelLoadingSkeletonComponent {
  /** Accessible name, e.g. "task". */
  @Input() entityLabel = 'record';
  /** Left sidebar: section heading + the field labels under it. */
  @Input() sidebarSections: PanelSkeletonSection[] = [];
  /** Main area: labels of the "Information" grid. */
  @Input() infoFields: string[] = [];
  @Input() infoTitle = 'Information';
  @Input() tabs: string[] = ['Details'];
  @Output() closeRequested = new EventEmitter<void>();
}
